import React, { useState, useEffect } from "react";
import EditProgramForm from "../../../../../../Components/EditProgramForm";
import { getAllMusic, getAllProgramsById, updatePrograms } from "../../programs.Apis";
import { useParams } from "react-router-dom";
import { uploadFile } from "../../../Blogs/others/Uploads/upload.Helper";
import { creatingStates } from "../../../Blogs/Constants";
import Loader from "../../../../../../Components/Loader";
import SweetAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const EditAllPrograms = () => {
  const { programId } = useParams();
  const history = useHistory()
  // console.log(programId, "ssdssdsdsds");
  const [showDeleteAlert, setShowDeleteAlert] = useState(false)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [programData, setProgramData] = useState({
    title: "",
    description: "",
    mediaIds: [],
    assetImage: "",
  });
  const [programData1, setProgramData1] = useState({
    title: "",
    description: "",
    mediaIds: [],
    assetImage: "",
  });
  const [programData2, setProgramData2] = useState({
    title: "",
    description: "",
    mediaIds: [],
    assetImage: "",
  });
  const [coverImage, setCoverImage] = useState("")
  const [coverImage1, setCoverImage1] = useState("")
  const [coverImage2, setCoverImage2] = useState("")

  const [contentUploadPercentage, setContentUploadPercentage] = useState(0);

  const [creating, setCreating] = useState({
    isCreating: false,
    creatingStage: creatingStates.UPLOADING_IMAGE,
  });
  const { isCreating, creatingStage } = creating;

  const [isLoading, setIsLoading] = useState(true);

  const [mediaSelectA, setMediaSelectA] = useState([])
  const [mediaSelectA1, setMediaSelectA1] = useState([])
  const [mediaSelectA2, setMediaSelectA2] = useState([])
  const [mediaSelectA3, setMediaSelectA3] = useState([])
  const [mediaSelectA4, setMediaSelectA4] = useState([])
  const [mediaSelectA5, setMediaSelectA5] = useState([])
  const [mediaSelectA6, setMediaSelectA6] = useState([])
  const [mediaSelectA7, setMediaSelectA7] = useState([])
  const [mediaSelectA8, setMediaSelectA8] = useState([])


  const [mediaSelectB, setMediaSelectB] = useState([])
  const [mediaSelectB1, setMediaSelectB1] = useState([])
  const [mediaSelectB2, setMediaSelectB2] = useState([])
  const [mediaSelectB3, setMediaSelectB3] = useState([])
  const [mediaSelectB4, setMediaSelectB4] = useState([])
  const [mediaSelectB5, setMediaSelectB5] = useState([])
  const [mediaSelectB6, setMediaSelectB6] = useState([])
  const [mediaSelectB7, setMediaSelectB7] = useState([])
  const [mediaSelectB8, setMediaSelectB8] = useState([])

  const [mediaSelectC, setMediaSelectC] = useState([])
  const [mediaSelectC1, setMediaSelectC1] = useState([])
  const [mediaSelectC2, setMediaSelectC2] = useState([])
  const [mediaSelectC3, setMediaSelectC3] = useState([])
  const [mediaSelectC4, setMediaSelectC4] = useState([])
  const [mediaSelectC5, setMediaSelectC5] = useState([])
  const [mediaSelectC6, setMediaSelectC6] = useState([])
  const [mediaSelectC7, setMediaSelectC7] = useState([])
  const [mediaSelectC8, setMediaSelectC8] = useState([])

  const [mediaData, setMediaData] = useState([])


  // const { title, description } = programData;



  // const getAllSlotDataById = async () => {
  //   try {
  //     setIsLoading(true);

  //     const { data } = await getAllProgramsById(programId);
  //     const programDataForTimeSlot = data.data.timeSlot[0].programData;
  //     const programDataForTimeSlot1 = data.data.timeSlot[1].programData;
  //     const programDataForTimeSlot2 = data.data.timeSlot[2].programData;


  //     setProgramData({
  //       title: programDataForTimeSlot.title,
  //       description: programDataForTimeSlot.description,
  //       // assetImage: programDataForTimeSlot.assetImage,
  //       mediaIds: programDataForTimeSlot.mediaIds,
  //     });
  //     setCoverImage(programDataForTimeSlot.assetImage)
  //     setMediaSelectA({
  //       key: programDataForTimeSlot.mediaIds[0]._id,
  //       value: programDataForTimeSlot.mediaIds[0]._id,
  //       label: programDataForTimeSlot.mediaIds[0].title,
  //     })
  //     setMediaSelectA1({
  //       key: programDataForTimeSlot.mediaIds[1]._id,
  //       value: programDataForTimeSlot.mediaIds[1]._id,
  //       label: programDataForTimeSlot.mediaIds[1].title,
  //     })
  //     setMediaSelectA2({
  //       key: programDataForTimeSlot.mediaIds[2]._id,
  //       value: programDataForTimeSlot.mediaIds[2]._id,
  //       label: programDataForTimeSlot.mediaIds[2].title,
  //     })
  //     setMediaSelectA3({
  //       key: programDataForTimeSlot.mediaIds[3]._id,
  //       value: programDataForTimeSlot.mediaIds[3]._id,
  //       label: programDataForTimeSlot.mediaIds[3].title,
  //     })
  //     setMediaSelectA4({
  //       key: programDataForTimeSlot.mediaIds[4]._id,
  //       value: programDataForTimeSlot.mediaIds[4]._id,
  //       label: programDataForTimeSlot.mediaIds[4].title,
  //     })
  //     setMediaSelectA5({
  //       key: programDataForTimeSlot.mediaIds[5]._id,
  //       value: programDataForTimeSlot.mediaIds[5]._id,
  //       label: programDataForTimeSlot.mediaIds[5].title,
  //     })
  //     setMediaSelectA6({
  //       key: programDataForTimeSlot.mediaIds[6]._id,
  //       value: programDataForTimeSlot.mediaIds[6]._id,
  //       label: programDataForTimeSlot.mediaIds[6].title,
  //     })
  //     setMediaSelectA7({
  //       key: programDataForTimeSlot.mediaIds[7]._id,
  //       value: programDataForTimeSlot.mediaIds[7]._id,
  //       label: programDataForTimeSlot.mediaIds[7].title,
  //     })
  //     setMediaSelectA8({
  //       key: programDataForTimeSlot.mediaIds[8]._id,
  //       value: programDataForTimeSlot.mediaIds[8]._id,
  //       label: programDataForTimeSlot.mediaIds[8].title,
  //     })

  //     setProgramData1({
  //       title: programDataForTimeSlot1.title,
  //       description: programDataForTimeSlot1.description,
  //       // assetImage: programDataForTimeSlot1.assetImage,
  //       mediaIds: programDataForTimeSlot1.mediaIds,
  //     })
  //     setCoverImage1(programDataForTimeSlot1.assetImage)
  //     setMediaSelectB({
  //       key: programDataForTimeSlot1.mediaIds[0]._id,
  //       value: programDataForTimeSlot1.mediaIds[0]._id,
  //       label: programDataForTimeSlot1.mediaIds[0].title,
  //     })
  //     setMediaSelectB1({
  //       key: programDataForTimeSlot1.mediaIds[1]._id,
  //       value: programDataForTimeSlot1.mediaIds[1]._id,
  //       label: programDataForTimeSlot1.mediaIds[1].title,
  //     })
  //     setMediaSelectB2({
  //       key: programDataForTimeSlot1.mediaIds[2]._id,
  //       value: programDataForTimeSlot1.mediaIds[2]._id,
  //       label: programDataForTimeSlot1.mediaIds[2].title,
  //     })
  //     setMediaSelectB3({
  //       key: programDataForTimeSlot1.mediaIds[3]._id,
  //       value: programDataForTimeSlot1.mediaIds[3]._id,
  //       label: programDataForTimeSlot1.mediaIds[3].title,
  //     })
  //     setMediaSelectB4({
  //       key: programDataForTimeSlot1.mediaIds[4]._id,
  //       value: programDataForTimeSlot1.mediaIds[4]._id,
  //       label: programDataForTimeSlot1.mediaIds[4].title,
  //     })
  //     setMediaSelectB5({
  //       key: programDataForTimeSlot1.mediaIds[5]._id,
  //       value: programDataForTimeSlot1.mediaIds[5]._id,
  //       label: programDataForTimeSlot1.mediaIds[5].title,
  //     })
  //     setMediaSelectB6({
  //       key: programDataForTimeSlot1.mediaIds[6]._id,
  //       value: programDataForTimeSlot1.mediaIds[6]._id,
  //       label: programDataForTimeSlot1.mediaIds[6].title,
  //     })
  //     setMediaSelectB7({
  //       key: programDataForTimeSlot1.mediaIds[7]._id,
  //       value: programDataForTimeSlot1.mediaIds[7]._id,
  //       label: programDataForTimeSlot1.mediaIds[7].title,
  //     })
  //     setMediaSelectB8({
  //       key: programDataForTimeSlot1.mediaIds[8]._id,
  //       value: programDataForTimeSlot1.mediaIds[8]._id,
  //       label: programDataForTimeSlot1.mediaIds[8].title,
  //     })

  //     setProgramData2({
  //       title: programDataForTimeSlot2.title,
  //       description: programDataForTimeSlot2.description,
  //       // assetImage: programDataForTimeSlot2.assetImage,
  //       mediaIds: programDataForTimeSlot2.mediaIds,
  //     })
  //     setCoverImage2(programDataForTimeSlot2.assetImage)
  //     setMediaSelectC({
  //       key: programDataForTimeSlot2.mediaIds[0]._id,
  //       value: programDataForTimeSlot2.mediaIds[0]._id,
  //       label: programDataForTimeSlot2.mediaIds[0].title,
  //     })
  //     setMediaSelectC1({
  //       key: programDataForTimeSlot2.mediaIds[1]._id,
  //       value: programDataForTimeSlot2.mediaIds[1]._id,
  //       label: programDataForTimeSlot2.mediaIds[1].title,
  //     })
  //     setMediaSelectC2({
  //       key: programDataForTimeSlot2.mediaIds[2]._id,
  //       value: programDataForTimeSlot2.mediaIds[2]._id,
  //       label: programDataForTimeSlot2.mediaIds[2].title,
  //     })
  //     setMediaSelectC3({
  //       key: programDataForTimeSlot2.mediaIds[3]._id,
  //       value: programDataForTimeSlot2.mediaIds[3]._id,
  //       label: programDataForTimeSlot2.mediaIds[3].title,
  //     })
  //     setMediaSelectC4({
  //       key: programDataForTimeSlot2.mediaIds[4]._id,
  //       value: programDataForTimeSlot2.mediaIds[4]._id,
  //       label: programDataForTimeSlot2.mediaIds[4].title,
  //     })
  //     setMediaSelectC5({
  //       key: programDataForTimeSlot2.mediaIds[5]._id,
  //       value: programDataForTimeSlot2.mediaIds[5]._id,
  //       label: programDataForTimeSlot2.mediaIds[5].title,
  //     })
  //     setMediaSelectC6({
  //       key: programDataForTimeSlot2.mediaIds[6]._id,
  //       value: programDataForTimeSlot2.mediaIds[6]._id,
  //       label: programDataForTimeSlot2.mediaIds[6].title,
  //     })
  //     setMediaSelectC7({
  //       key: programDataForTimeSlot2.mediaIds[7]._id,
  //       value: programDataForTimeSlot2.mediaIds[7]._id,
  //       label: programDataForTimeSlot2.mediaIds[7].title,
  //     })
  //     setMediaSelectC8({
  //       key: programDataForTimeSlot2.mediaIds[8]._id,
  //       value: programDataForTimeSlot2.mediaIds[8]._id,
  //       label: programDataForTimeSlot2.mediaIds[8].title,
  //     })

  //   } catch (error) {
  //     console.log(error);
  //   }
  //   setIsLoading(false);
  // };

  const getAllSlotDataById = async () => {
    try {
      setIsLoading(true);

      const { data } = await getAllProgramsById(programId);
      const timeSlots = data.data.timeSlot;

      // Helper function to process program data
      const processProgramData = (programData) => {
        return {
          title: programData?.title || "",
          description: programData?.description || "",
          mediaIds: programData?.mediaIds || [],
          assetImage: programData?.assetImage || ""
        };
      };

      // Helper function to process media selections
      const processMediaSelections = (mediaIds, setterFunctions) => {
        mediaIds?.forEach((media, index) => {
          if (media && setterFunctions[index]) {
            setterFunctions[index]({
              key: media._id,
              value: media._id,
              label: media.title
            });
          }
        });
      };

      // Process first time slot (4:00 AM)
      const programDataForTimeSlot = processProgramData(timeSlots[0]?.programData);
      setProgramData(programDataForTimeSlot);
      setCoverImage(programDataForTimeSlot.assetImage);

      processMediaSelections(programDataForTimeSlot.mediaIds, [
        setMediaSelectA,
        setMediaSelectA1,
        setMediaSelectA2,
        setMediaSelectA3,
        setMediaSelectA4,
        setMediaSelectA5,
        setMediaSelectA6,
        setMediaSelectA7,
        setMediaSelectA8
      ]);

      // Process second time slot (12:00 PM)
      const programDataForTimeSlot1 = processProgramData(timeSlots[1]?.programData);
      setProgramData1(programDataForTimeSlot1);
      setCoverImage1(programDataForTimeSlot1.assetImage);

      processMediaSelections(programDataForTimeSlot1.mediaIds, [
        setMediaSelectB,
        setMediaSelectB1,
        setMediaSelectB2,
        setMediaSelectB3,
        setMediaSelectB4,
        setMediaSelectB5,
        setMediaSelectB6,
        setMediaSelectB7,
        setMediaSelectB8
      ]);

      // Process third time slot (5:00 PM)
      const programDataForTimeSlot2 = processProgramData(timeSlots[2]?.programData);
      setProgramData2(programDataForTimeSlot2);
      setCoverImage2(programDataForTimeSlot2.assetImage);

      processMediaSelections(programDataForTimeSlot2.mediaIds, [
        setMediaSelectC,
        setMediaSelectC1,
        setMediaSelectC2,
        setMediaSelectC3,
        setMediaSelectC4,
        setMediaSelectC5,
        setMediaSelectC6,
        setMediaSelectC7,
        setMediaSelectC8
      ]);

    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const getAllMusicMediaId = async () => {
    try {
      const { data } = await getAllMusic()
      setMediaData(data.data)
    }
    catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getAllSlotDataById();
    getAllMusicMediaId()
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault()

    try {
      let coverUrl = coverImage;
      let coverUrl1 = coverImage1;
      let coverUrl2 = coverImage2;

      // let blogUrl = null;


      if (coverImage && typeof coverImage !== "string") {
        setCreating({
          isCreating: true,
          creatingStage: creatingStates.UPLOADING_IMAGE,
        });
        coverUrl = await uploadFile(
          coverImage,
          "IMAGE",
          setContentUploadPercentage,
          50
        );
      } else setContentUploadPercentage(50);

      if (coverImage1 && typeof coverImage1 !== "string") {
        setCreating({
          isCreating: true,
          creatingStage: creatingStates.UPLOADING_IMAGE,
        });
        coverUrl1 = await uploadFile(
          coverImage1,
          "IMAGE",
          setContentUploadPercentage,
          50
        );
      } else setContentUploadPercentage(50);

      if (coverImage2 && typeof coverImage2 !== "string") {
        setCreating({
          isCreating: true,
          creatingStage: creatingStates.UPLOADING_IMAGE,
        });
        coverUrl2 = await uploadFile(
          coverImage2,
          "IMAGE",
          setContentUploadPercentage,
          50
        );
      } else setContentUploadPercentage(50);


      const allTimeSlots = [
        {
          time: "4:00 AM",
          programData: {
            title: programData.title,
            description: programData.description,
            assetImage: coverUrl,
            order: "1",
            // mediaIds: [mediaSelectA.value, mediaSelectA1.value, mediaSelectA2.value, mediaSelectA3.value, mediaSelectA4.value, mediaSelectA5.value, mediaSelectA6.value, mediaSelectA7.value, mediaSelectA8.value],
            mediaIds: [
              mediaSelectA?.value || null,
              mediaSelectA1?.value || null,
              mediaSelectA2?.value || null,
              mediaSelectA3?.value || null,
              mediaSelectA4?.value || null,
              mediaSelectA5?.value || null,
              mediaSelectA6?.value || null,
              mediaSelectA7?.value || null,
              mediaSelectA8?.value || null,

            ].filter(id => id !== null)
          }
        },
        {
          time: "12:00 PM",
          programData: {
            title: programData1.title,
            description: programData1.description,
            assetImage: coverUrl1,
            order: "2",
            // mediaIds: [mediaSelectB.value, mediaSelectB1.value, mediaSelectB2.value, mediaSelectB3.value, mediaSelectB4.value, mediaSelectB5.value, mediaSelectB6.value, mediaSelectB7.value, mediaSelectB8.value]
            mediaIds: [
              mediaSelectB?.value || null,
              mediaSelectB1?.value || null,
              mediaSelectB2?.value || null,
              mediaSelectB3?.value || null,
              mediaSelectB4?.value || null,
              mediaSelectB5?.value || null,
              mediaSelectB6?.value || null,
              mediaSelectB7?.value || null,
              mediaSelectB8?.value || null,

            ].filter(id => id !== null)
          }
        },
        {
          time: "5:00 PM",
          programData: {
            title: programData2.title,
            description: programData2.description,
            assetImage: coverUrl2,
            order: "3",
            // mediaIds: [mediaSelectC.value, mediaSelectC1.value, mediaSelectC2.value, mediaSelectC3.value, mediaSelectC4.value, mediaSelectC5.value, mediaSelectC6.value, mediaSelectC7.value, mediaSelectC8.value]
            mediaIds: [
              mediaSelectC?.value || null,
              mediaSelectC1?.value || null,
              mediaSelectC2?.value || null,
              mediaSelectC3?.value || null,
              mediaSelectC4?.value || null,
              mediaSelectC5?.value || null,
              mediaSelectC6?.value || null,
              mediaSelectC7?.value || null,
              mediaSelectC8?.value || null,

            ].filter(id => id !== null)
          }
        },
      ]

      const validTimeSlots = allTimeSlots.filter(slot => {
        const { title, description, assetImage } = slot.programData;
        return title && description && assetImage;
      });

      await updatePrograms(programId, {
        timeSlot: validTimeSlots
      });

    } catch (error) {
      console.log(error);
    }
    // window.location.reload()
    setShowDeleteAlert(false);
    setShowDeleteConfirm(true);
  }
  console.log(mediaSelectA.value, 'asdfasdf')

  const handleMediaSelectChangeA = (selectedOption) => {
    setMediaSelectA(selectedOption);
  };
  const handleMediaSelectChangeA1 = (selectedOption) => {
    setMediaSelectA1(selectedOption);
  };
  const handleMediaSelectChangeA2 = (selectedOption) => {
    setMediaSelectA2(selectedOption);
  };
  const handleMediaSelectChangeA3 = (selectedOption) => {
    setMediaSelectA3(selectedOption);
  };
  const handleMediaSelectChangeA4 = (selectedOption) => {
    setMediaSelectA4(selectedOption);
  };
  const handleMediaSelectChangeA5 = (selectedOption) => {
    setMediaSelectA5(selectedOption);
  };
  const handleMediaSelectChangeA6 = (selectedOption) => {
    setMediaSelectA6(selectedOption);
  };
  const handleMediaSelectChangeA7 = (selectedOption) => {
    setMediaSelectA7(selectedOption);
  };
  const handleMediaSelectChangeA8 = (selectedOption) => {
    setMediaSelectA8(selectedOption);
  };
  const handleMediaSelectChangeB = (selectedOption) => {
    setMediaSelectB(selectedOption);
  };
  const handleMediaSelectChangeB1 = (selectedOption) => {
    setMediaSelectB1(selectedOption);
  };
  const handleMediaSelectChangeB2 = (selectedOption) => {
    setMediaSelectB2(selectedOption);
  };
  const handleMediaSelectChangeB3 = (selectedOption) => {
    setMediaSelectB3(selectedOption);
  };
  const handleMediaSelectChangeB4 = (selectedOption) => {
    setMediaSelectB4(selectedOption);
  };
  const handleMediaSelectChangeB5 = (selectedOption) => {
    setMediaSelectB5(selectedOption);
  };
  const handleMediaSelectChangeB6 = (selectedOption) => {
    setMediaSelectB6(selectedOption);
  };
  const handleMediaSelectChangeB7 = (selectedOption) => {
    setMediaSelectB7(selectedOption);
  };
  const handleMediaSelectChangeB8 = (selectedOption) => {
    setMediaSelectB8(selectedOption);
  };
  const handleMediaSelectChangeC = (selectedOption) => {
    setMediaSelectC(selectedOption);
  };
  const handleMediaSelectChangeC1 = (selectedOption) => {
    setMediaSelectC1(selectedOption);
  };
  const handleMediaSelectChangeC2 = (selectedOption) => {
    setMediaSelectC2(selectedOption);
  };
  const handleMediaSelectChangeC3 = (selectedOption) => {
    setMediaSelectC3(selectedOption);
  };
  const handleMediaSelectChangeC4 = (selectedOption) => {
    setMediaSelectC4(selectedOption);
  };
  const handleMediaSelectChangeC5 = (selectedOption) => {
    setMediaSelectC5(selectedOption);
  };
  const handleMediaSelectChangeC6 = (selectedOption) => {
    setMediaSelectC6(selectedOption);
  };
  const handleMediaSelectChangeC7 = (selectedOption) => {
    setMediaSelectC7(selectedOption);
  };
  const handleMediaSelectChangeC8 = (selectedOption) => {
    setMediaSelectC8(selectedOption);
  };

  const handleChange = (e) => {
    setProgramData({
      ...programData,
      [e.target.name]: e.target.value
    })
  }
  const handleChange1 = (e) => {
    setProgramData1({
      ...programData1,
      [e.target.name]: e.target.value
    })
  }
  const handleChange2 = (e) => {
    setProgramData2({
      ...programData2,
      [e.target.name]: e.target.value
    })
  }

  const mediaOptions = mediaData.map(item => ({
    value: item._id,
    label: item.title
  }));

  return (
    <>
      {isLoading ? (<Loader />) : <EditProgramForm
        time="4:00 AM"
        time1="12:00 PM"
        time2="5:00 PM"
        title={programData.title}
        description={programData.description}
        mediaIds={programData.mediaIds}

        mediaSelecta={mediaSelectA}
        handleMediaSelectChangeA={handleMediaSelectChangeA}
        mediaSelecta1={mediaSelectA1}
        handleMediaSelectChangeA1={handleMediaSelectChangeA1}
        mediaSelecta2={mediaSelectA2}
        handleMediaSelectChangeA2={handleMediaSelectChangeA2}
        mediaSelecta3={mediaSelectA3}
        handleMediaSelectChangeA3={handleMediaSelectChangeA3}
        mediaSelecta4={mediaSelectA4}
        handleMediaSelectChangeA4={handleMediaSelectChangeA4}
        mediaSelecta5={mediaSelectA5}
        handleMediaSelectChangeA5={handleMediaSelectChangeA5}
        mediaSelecta6={mediaSelectA6}
        handleMediaSelectChangeA6={handleMediaSelectChangeA6}
        mediaSelecta7={mediaSelectA7}
        handleMediaSelectChangeA7={handleMediaSelectChangeA7}
        mediaSelecta8={mediaSelectA8}
        handleMediaSelectChangeA8={handleMediaSelectChangeA8}

        mediaSelectb={mediaSelectB}
        handleMediaSelectChangeB={handleMediaSelectChangeB}
        mediaSelectb1={mediaSelectB1}
        handleMediaSelectChangeB1={handleMediaSelectChangeB1}
        mediaSelectb2={mediaSelectB2}
        handleMediaSelectChangeB2={handleMediaSelectChangeB2}
        mediaSelectb3={mediaSelectB3}
        handleMediaSelectChangeB3={handleMediaSelectChangeB3}
        mediaSelectb4={mediaSelectB4}
        handleMediaSelectChangeB4={handleMediaSelectChangeB4}
        mediaSelectb5={mediaSelectB5}
        handleMediaSelectChangeB5={handleMediaSelectChangeB5}
        mediaSelectb6={mediaSelectB6}
        handleMediaSelectChangeB6={handleMediaSelectChangeB6}
        mediaSelectb7={mediaSelectB7}
        handleMediaSelectChangeB7={handleMediaSelectChangeB7}
        mediaSelectb8={mediaSelectB8}
        handleMediaSelectChangeB8={handleMediaSelectChangeB8}


        mediaSelectc={mediaSelectC}
        handleMediaSelectChangeC={handleMediaSelectChangeC}
        mediaSelectc1={mediaSelectC1}
        handleMediaSelectChangeC1={handleMediaSelectChangeC1}
        mediaSelectc2={mediaSelectC2}
        handleMediaSelectChangeC2={handleMediaSelectChangeC2}
        mediaSelectc3={mediaSelectC3}
        handleMediaSelectChangeC3={handleMediaSelectChangeC3}
        mediaSelectc4={mediaSelectC4}
        handleMediaSelectChangeC4={handleMediaSelectChangeC4}
        mediaSelectc5={mediaSelectC5}
        handleMediaSelectChangeC5={handleMediaSelectChangeC5}
        mediaSelectc6={mediaSelectC6}
        handleMediaSelectChangeC6={handleMediaSelectChangeC6}
        mediaSelectc7={mediaSelectC7}
        handleMediaSelectChangeC7={handleMediaSelectChangeC7}
        mediaSelectc8={mediaSelectC8}
        handleMediaSelectChangeC8={handleMediaSelectChangeC8}

        mediaData={mediaOptions}
        title1={programData1.title}
        description1={programData1.description}
        title2={programData2.title}
        description2={programData2.description}
        coverImage={coverImage}
        setCoverImage={setCoverImage}
        coverImage1={coverImage1}
        setCoverImage1={setCoverImage1}
        coverImage2={coverImage2}
        setCoverImage2={setCoverImage2}
        handleUpdateProgram={handleUpdate}
        handleChange={handleChange}
        handleChange1={handleChange1}
        handleChange2={handleChange2}

      />}
      {showDeleteAlert ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, Delete it!"
          reverseButtons={true}
          onConfirm={() => {
            handleUpdate()

          }}
          onCancel={() => setShowDeleteAlert(false)}
        ></SweetAlert>
      ) : null}
      {showDeleteConfirm ? (
        <SweetAlert
          success
          title="Changes Saved"
          onConfirm={() => {

            setShowDeleteAlert(false);
            setShowDeleteConfirm(false)
            history.push("/dashboard/programs/all")
          }}
        ></SweetAlert>
      ) : null}
    </>
  );
};

export default EditAllPrograms;